import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

const LavermicoccaPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#efece9',
      100: '#dfd9d3',
      200: '#beb2a7',
      300: '#9e8c7b',
      400: '#7d654f',
      500: '#5d3f23',
      600: '#4a321c',
      700: '#382615',
      800: '#22170d', // base color
      900: '#1a1109',
      950: '#100a05',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#22170d',
          hoverColor: '#A0CBB1',
          activeColor: '#00356C',
        },
        highlight: {
          background: '#E6E4E4',
        },
        surface: {
          0: '#FFFFFF',
          100: '#f4f2ef',
        },
        text: {
          color: '#22170d',
        },
      },
      dark: {
        primary: {
          color: '#e6eef5',
          hoverColor: '#c0d4e6',
          activeColor: '#99b9d6',
        },
        surface: {
          0: '#1A1A1A',
        },
      },
    },
  },
  components: {
    button: {
      colorScheme: {
        light: {
          outlined: {
            primary: {
              borderColor: '{primary.color}',
              color: '{primary.color}',
              hoverBackground: '{primary.50}',
              activeBackground: '{primary.100}',
            },
            secondary: {
              borderColor: '#a0cbb1',
              color: '#a0cbb1',
              hoverBackground: 'rgba(160, 203, 177, 0.15)',
              activeBackground: 'rgba(160, 203, 177, 0.25)',
            },
          },
        },
        dark: {
          outlined: {
            primary: {
              borderColor: '{primary.color}',
              color: '{primary.color}',
            },
            secondary: {
              borderColor: '#ffffff',
              color: '#ffffff',
              hoverBackground: 'rgba(255, 255, 255, 0.12)',
              activeBackground: 'rgba(255, 255, 255, 0.2)',
            },
          },
        },
      },
    },
  },
});

export default LavermicoccaPreset;
